<template>
  <v-dialog v-model="visible" max-width="800px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12" lg="6">
              <v-select
                v-model="unidadNegocioSeleccionadaId"
                :items="unidadesNegocios"
                item-text="nombre"
                item-value="id"
                label="Unidad de Negocio"
                required
                outlined
                dense
                hide-details
                clearable
                @change="
                  () => {
                    form.categoriaId = null;
                    form.conceptoPagoId = null;
                    obtenerConceptosPagosUnidadNegocio();
                  }
                "></v-select>
            </v-col>

            <v-col cols="12" lg="6">
              <v-select
                v-model="form.categoriaId"
                :items="categoriasFiltradas"
                item-text="nombre"
                item-value="id"
                label="Categorías"
                :disabled="unidadesNegocios.length === 0 || !unidadNegocioSeleccionadaId"
                outlined
                dense
                hide-details
                clearable>
                <template #item="{ item }">
                  <v-list>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ unidadesNegocios.find((unidadNegocio) => unidadNegocio.id == item.unidadNegocioId)?.nombre }}
                    </v-list-item-subtitle>
                  </v-list>
                </template>
              </v-select>

              <small v-for="error in errores.categoriaId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.conceptoPagoId"
                :items="conceptosPagosUnidadNegocioFiltrados"
                item-text="conceptoPago.nombre"
                item-value="conceptoPago.id"
                label="Conceptos de pago"
                :disabled="unidadesNegocios.length === 0 || !unidadNegocioSeleccionadaId"
                outlined
                dense
                hide-details
                clearable>
                <template #item="{ item }">
                  <v-list>
                    <v-list-item-title>{{ item.conceptoPago.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ unidadesNegocios.find((unidadNegocio) => unidadNegocio.id == item.unidadNegocioId)?.nombre }}
                    </v-list-item-subtitle>
                  </v-list>
                </template>
              </v-select>

              <small v-for="error in errores.conceptoPagoId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="6">
              <v-checkbox
                v-model="form.esMontoTotal"
                label="Es monto total"
                :disabled="!form.conceptoPagoId"
                hide-details
                @change="onchangeEsMontoTotal"></v-checkbox>
            </v-col>

            <v-col cols="12" lg="6">
              <v-text-field
                v-model="form.hastaCuota"
                label="Hasta cuota"
                type="number"
                min="0"
                :disabled="!form.conceptoPagoId || form.esMontoTotal"
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.hastaCuota" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="guardando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" :disabled="guardando" :loading="guardando" text @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../../mixins/modal-form.mixin';
import apiConsumerMixin from '../../mixins/api-consumer.mixin';
import CategoriasService from '../../services/categorias.service';
import { ACCIONES } from '../../utils/constantes';
import RequisitoFinancieroService from '../../services/requisitos-financieros.service';
import unidadesNegociosService from '../../services/unidades-negocios.service';
import conceptoPagoUnidadNegocioService from '../../services/concepto-pago-unidad-negocio.service';

export default {
  name: 'ModalFormularioRequisitosFinancieros',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    institucionId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    'form.categoriaId': function () {
      this.errores.categoriaId = [];
    },
    'form.conceptoPagoId': function () {
      this.errores.conceptoPagoId = [];
    },
    'form.hastaCuota': function () {
      this.errores.hastaCuota = [];
    },
  },
  computed: {
    categoriasFiltradas() {
      return this.categorias.filter((categoria) => categoria.unidadNegocioId == this.unidadNegocioSeleccionadaId);
    },
    conceptosPagosUnidadNegocioFiltrados() {
      return this.conceptosPagosUnidadNegocio.filter(
        (conceptoPagoUnidadNegocio) => conceptoPagoUnidadNegocio.unidadNegocioId == this.unidadNegocioSeleccionadaId,
      );
    },
  },
  data() {
    return {
      conceptosPagosUnidadNegocio: [],
      categorias: [],
      unidadesNegocios: [],
      unidadNegocioSeleccionadaId: null,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      this.unidadNegocioSeleccionadaId = null;

      return {
        id: null,
        institucionId: this.institucionId,
        institucion: null,
        categoriaId: null,
        categoria: null,
        conceptoPagoId: null,
        conceptoPago: null,
        esMontoTotal: false,
        hastaCuota: null,
      };
    },
    generarObjetoFormEditar(data) {
      this.unidadNegocioSeleccionadaId = data.categoria.unidadNegocioId;

      return {
        id: data.id,
        institucionId: data.institucionId,
        institucion: data.institucion,
        categoriaId: data.categoriaId,
        categoria: data.categoria,
        conceptoPagoId: data.conceptoPagoId,
        conceptoPago: data.conceptoPago,
        esMontoTotal: data.esMontoTotal,
        hastaCuota: data.hastaCuota,
      };
    },
    abrir(accion, data = []) {
      Promise.all([
        this.obtenerUnidadesNegocios(),
        this.obtenerCategorias(),
        this.obtenerConceptosPagosUnidadNegocio(),
      ]).then(() => {
        this.abrirMixin(accion, data);
      });
    },
    cerrar() {
      this.cerrarMixin();
    },
    async obtenerConceptosPagosUnidadNegocio() {
      await this.findAllMixin(
        conceptoPagoUnidadNegocioService.findAll,
        null,
        'CONCEPTOS DE PAGO POR UNIDAD DE NEGOCIO',
        () => {
          this.conceptosPagosUnidadNegocio = [];
        },
        null,
        (datos) => {
          this.conceptosPagosUnidadNegocio = datos;
        },
        () => {
          this.conceptosPagosUnidadNegocio = [];
        },
      );
    },
    async obtenerCategorias() {
      await this.findAllMixin(
        CategoriasService.findAll,
        null,
        'CATEGORÍAS',
        () => {
          this.categorias = [];
        },
        null,
        (datos) => {
          this.categorias = datos;
        },
        () => {
          this.categorias = [];
        },
      );
    },
    async obtenerUnidadesNegocios() {
      await this.findAllMixin(
        unidadesNegociosService.findAll,
        null,
        'UNIDADES NEGOCIOS',
        () => {
          this.unidadesNegocios = [];
        },
        null,
        (datos) => {
          this.unidadesNegocios = datos;
        },
        () => {
          this.unidadesNegocios = [];
        },
      );
    },
    onchangeEsMontoTotal() {
      if (this.form.esMontoTotal) {
        this.form.hastaCuota = null;
      } else {
        this.form.hastaCuota = 1;
      }
    },
    async guardar() {
      if (this.guardando) {
        return;
      }

      const accion = this.form?.id ? ACCIONES.EDITAR : ACCIONES.REGISTRAR;
      const fnServicio = this.form?.id ? RequisitoFinancieroService.update : RequisitoFinancieroService.create;

      await this.saveMixin(
        accion,
        fnServicio,
        this.form,
        null,
        'REQUISITO FINANCIERO',
        () => {
          this.guardando = true;
          this.errores = [];
        },
        () => {
          this.guardando = false;
        },
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          if (typeof errores === 'object') {
            this.errores = errores;
          }
        },
      );
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>